import { defineStore } from 'pinia';
import api from '../../api';

export const useMirroringStore = defineStore('mirroring', {
  state: () => ({
    devicePortMirroring: {}
  }),

  actions: {
    queryPortMirroringInfo(params) {
      return api.mirroring.queryPortMirroringInfo(params)
        .then(data => {
          if (data.resp.respCode == 0) {
            this.devicePortMirroring = data.devicePortMirroring;
          }
        })
        .catch(error => {
          throw error;
        });
    },
    setDevicePortMirroring(data) {
      this.devicePortMirroring = data
    },
    switchPortMirroring(params) {
      return api.mirroring.switchPortMirroring(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },

    updatePortMirroring(params) {
      return api.mirroring.updatePortMirroring(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
  }
});
